'use client';

import { Card } from '@hc-frontend/core-ui';
import type { MouseEventHandler } from 'react';

import type { TypAdCardProps } from './typ-ad-card.types';

export function TypAdCard({
  children,
  onClick,
  linkDataAttribute,
  ...props
}: TypAdCardProps) {
  const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
    const link = e.currentTarget.querySelector<HTMLAnchorElement>(
      `[${linkDataAttribute}]`,
    );
    link?.click();
    onClick?.(e);
  };

  return (
    <Card {...props} onClick={handleClick}>
      {children}
    </Card>
  );
}
